import { Component, Input } from '@angular/core';
import { Order } from '../../../interfaces/order.interface';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-order-step',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './order-step.component.html',
  styleUrl: './order-step.component.css'
})
export class OrderStepComponent {
  @Input() order!: Order;
  @Input() orientation!: 'portrait' | 'landscape';

  /**
   * El backend ya entrega completedSteps. Para la representación visual se usa
   * ese índice como fuente de verdad, evitando que un flag individual incompleto
   * o desfasado oculte los hitos anteriores.
   */
  get currentStepIndex(): number {
    if (!this.order?.steps?.length) {
      return -1;
    }

    if (this.order.completedSteps != null && this.order.completedSteps > 0) {
      return Math.min(this.order.completedSteps - 1, this.order.steps.length - 1);
    }

    const lastCompletedIdx = this.order.steps.reduce(
      (last, step, idx) => (step.completed ? idx : last),
      -1
    );
    if (lastCompletedIdx >= 0) {
      return lastCompletedIdx;
    }

    return 0;
  }

  isPastStep(index: number): boolean {
    return index < this.currentStepIndex;
  }

  isCurrentStep(index: number): boolean {
    return index === this.currentStepIndex;
  }

  isPendingStep(index: number): boolean {
    return index > this.currentStepIndex || this.currentStepIndex < 0;
  }

  isLeftSegmentCompleted(index: number): boolean {
    return this.currentStepIndex >= 0 && index <= this.currentStepIndex;
  }

  isRightSegmentCompleted(index: number): boolean {
    return this.currentStepIndex >= 0 && index < this.currentStepIndex;
  }
}
